import { useState, ReactElement } from "react";

import "./WorkplaceDialog.css";
import { Button, Pagination } from "react-bulma-components";
import styled from "styled-components";
import { useDebounce } from "use-debounce";

import { CommutingRouteProp } from "components/CommutingRouteDialog/CommutingRouteDialog";
import { RESPONSIVE } from "helpers/responsive";
import { useSuggestedAddresses } from "hooks/addresses";
import Address from "models/address";
import { Paginate } from "models/paginate";
import * as Table from "molecules/Table";

const WorkplaceDialogModalCard = styled.div`
  height: calc(100vh - 40px);

  @media ${RESPONSIVE.DESKTOP} {
    width: 1024px;
  }
`;

const WorkplaceThAction = styled(Table.Th)`
  width: 68px;

  @media ${RESPONSIVE.DESKTOP} {
    width: 120px;
  }
`;

const WorkplaceTdAction = styled(Table.Td)`
  text-align: center !important;
`;

const renderDialog = (
  handleClose: () => void,
  handleWorkplaceSelect: (
    commutingRouteProp: CommutingRouteProp,
    workplace: Address
  ) => void,
  workplaceName: string,
  setWorkplaceName: (workplaceName_: string) => void,
  currentPage: number,
  setCurrentPage: (page: number) => void,
  suggestedAddresses: Paginate<Address>,
  isVisible: boolean,
  commutingRouteProp: CommutingRouteProp
) => (
  <div className={`modal cw-workplace-dialog ${isVisible ? "is-active" : ""}`}>
    <div className="modal-background" />
    <WorkplaceDialogModalCard className="modal-card">
      <header className="modal-card-head">
        <p className="modal-card-title">勤務地変更</p>
        <button
          type="button"
          className="delete"
          aria-label="close"
          onClick={(_event) => handleClose()}
        />
      </header>

      <section className="modal-card-body">
        <div className="cw-new-workplace-dialog-header">
          <Table.Table>
            <tbody>
              <tr>
                <Table.ThMedium>勤務地名</Table.ThMedium>
                <Table.Td>
                  <input
                    className="input"
                    type="text"
                    value={workplaceName}
                    onChange={(event) => setWorkplaceName(event.target.value)}
                  />
                </Table.Td>
              </tr>
            </tbody>
          </Table.Table>
        </div>

        <Pagination
          current={currentPage}
          showFirstLast
          total={suggestedAddresses.totalPages}
          onChange={(page) => {
            setCurrentPage(page);
          }}
        />
        <Table.Table>
          <thead>
            <tr>
              <Table.Th>店舗名</Table.Th>
              <Table.Th>住所</Table.Th>
              <WorkplaceThAction />
            </tr>
          </thead>
          <tbody>
            {suggestedAddresses.datas.map((suggestedAddress, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={index}>
                <Table.Td>{suggestedAddress.name}</Table.Td>
                <Table.Td>{suggestedAddress.address}</Table.Td>
                <WorkplaceTdAction>
                  <Button
                    color="primary"
                    onClick={() => {
                      handleWorkplaceSelect(
                        commutingRouteProp,
                        suggestedAddress
                      );
                    }}
                  >
                    選択
                  </Button>
                </WorkplaceTdAction>
              </tr>
            ))}
          </tbody>
        </Table.Table>
      </section>
      <footer className="modal-card-foot">
        <Button onClick={() => handleClose()}>キャンセル</Button>
      </footer>
    </WorkplaceDialogModalCard>
  </div>
);

export interface WorkplaceDialogProps {
  toggleDialog: () => void;
  changeWorkplace: (
    commutingRouteProp: CommutingRouteProp,
    workplace: Address
  ) => void;
  isVisible: boolean;
  commutingRouteProp: CommutingRouteProp;
}

export function WorkplaceDialog({
  toggleDialog,
  changeWorkplace,
  isVisible,
  commutingRouteProp,
}: WorkplaceDialogProps): ReactElement | null {
  const [workplaceName, setWorkplaceName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [debouncedWorkplaceName] = useDebounce(workplaceName, 500);
  const suggestedAddresses = useSuggestedAddresses(
    debouncedWorkplaceName,
    currentPage
  );

  const initState = () => {
    setWorkplaceName("");
    setCurrentPage(1);
  };

  const handleClose = () => {
    toggleDialog();
    initState();
  };

  const handleWorkplaceSelect = (
    commutingRouteProp_: CommutingRouteProp,
    workplace: Address
  ) => {
    changeWorkplace(commutingRouteProp_, workplace);
    toggleDialog();
    initState();
  };

  return (
    <>
      {renderDialog(
        handleClose,
        handleWorkplaceSelect,
        workplaceName,
        setWorkplaceName,
        currentPage,
        setCurrentPage,
        suggestedAddresses,
        isVisible,
        commutingRouteProp
      )}
    </>
  );
}
